<ng-container *transloco="let t; prefix: 'dod-directory-sorting'">
  @if (!isMobile()) {
    <accredible-select-input
      [attr.aria-label]="t('aria_sort_by')"
      [formControlRef]="sortingOptionsControl"
      [options]="options()"
      [noError]="true"
      [menuWidthEqualsButtonWidth]="true"
      (valueChange)="sortChanged($event)" />
  } @else {
    <button
      data-cy="btn-mobile-sorting-trigger"
      class="mobile-sorting-trigger"
      [attr.aria-label]="t('aria_sort_by')"
      aria-haspopup="listbox"
      [attr.aria-expanded]="mobilePopUpVisible()"
      [accredibleMobilePopUpTriggerFor]="mobileSortingOptionsPopUp"
      (popUpToggled)="onPopupClosed()"
      (keydown.enter)="showPopup()"
      (keydown.space)="showPopup()"
      (click)="mobilePopUpVisible.set(!mobilePopUpVisible())">
      <div class="current-sorting-value">
        <span> {{ selectedValue() }} </span>
      </div>

      <div class="icon">
        <accredible-icon [icon]="'chevron-down'" />
      </div>
    </button>
  }

  <accredible-mobile-pop-up
    #mobileSortingOptionsPopUp
    [title]="t('sort_by')"
    [ignoreTheming]="true">
    <div class="mobile-popup">
      <ul class="options-list" role="listbox">
        @for (option of options(); track option; let i = $index) {
          <li
            id="option-{{ i }}"
            class="options-list-item"
            role="option"
            [attr.tabindex]="option.value === sortingOptionsControl.value ? '0' : '-1'"
            [attr.aria-selected]="option.value === sortingOptionsControl.value"
            [class.selected]="option.value === sortingOptionsControl.value"
            (click)="sortChanged(option.value)"
            (keydown)="onKeydown($event, option, i)">
            <span>{{ option.name }}</span>
            @if (option.value === sortingOptionsControl.value) {
              <accredible-icon [icon]="'check'" />
            }
          </li>
        }
      </ul>
    </div>
  </accredible-mobile-pop-up>
</ng-container>
